import { render, staticRenderFns } from "./AnalysisMainPage.vue?vue&type=template&id=dfd6bd74&scoped=true"
import script from "./AnalysisMainPage.vue?vue&type=script&lang=js"
export * from "./AnalysisMainPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd6bd74",
  null
  
)

export default component.exports